// zin-ui web component registration for the whole app
import { defineCustomElements } from '@tnl/zin-ui/loader'

defineCustomElements()
